import type React from 'react'
import type { AIStateStore } from '../../components/Mindmap/hooks/AIStateStore'
import {
  AIStateStoreContext,
  AICallbacksContext,
  type AICallbacksContextValue,
} from './AIGenerationContextDef'

/**
 * Provider for the AI state store
 */
export const AIStateStoreProvider: React.FC<{
  store: AIStateStore | null
  children: React.ReactNode
}> = ({ store, children }) => {
  return <AIStateStoreContext.Provider value={store}>{children}</AIStateStoreContext.Provider>
}

/**
 * Provider component for AI callbacks context
 */
export const AICallbacksProvider: React.FC<{
  value: AICallbacksContextValue
  children: React.ReactNode
}> = ({ value, children }) => {
  return <AICallbacksContext.Provider value={value}>{children}</AICallbacksContext.Provider>
}
